import React from 'react';

/* eslint-disable max-len */
const PetsIcon = _ref => {
  let {
    className,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M3.47528 13.0742L1.00488 23.3142C1.00488 25.3782 7.72488 27.0486 16.0001 27.0486C24.2753 27.0486 30.9953 25.3782 30.9953 23.3142L28.5249 13.0742",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47528 13.0742L1.00488 23.3142C1.00488 25.3782 7.72488 27.0486 16.0001 27.0486C24.2753 27.0486 30.9953 25.3782 30.9953 23.3142L28.5249 13.0742",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1652 10.5309L25.434 10.6173C27.354 11.2573 28.5252 12.1341 28.5252 13.0749C28.5252 15.1389 22.9188 16.8093 16.0004 16.8093C9.08199 16.8093 3.47559 15.1389 3.47559 13.0749C3.47559 12.0093 4.97639 11.0461 7.38599 10.3645L7.60039 10.3037C13.3595 8.72086 19.4489 8.79963 25.1652 10.5309Z",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.506 7.76537L18.6468 8.14937L17.3828 6.72857L17.9844 4.92697L19.8436 4.54297L21.1044 5.96377L20.506 7.76537Z",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6943 14.2496L9.08154 13.248L9.13914 11.3504L10.8127 10.4512L12.4255 11.4528L12.3679 13.3504L10.6943 14.2496Z",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2591 8.77704L11.7407 6.94984L13.0655 5.58984L14.9055 6.05384L15.4239 7.88104L14.0991 9.24424L12.2591 8.77704Z",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3598 14.4071L15.4718 14.6151L14.3486 13.0855L15.1134 11.3447L16.9982 11.1367L18.1246 12.6695L17.3598 14.4071Z",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1603 13.732L20.3171 13.2776L19.7891 11.4536L21.1043 10.084L22.9475 10.5384L23.4755 12.3624L22.1603 13.732Z",
    fill: "white",
    stroke: "#323254",
    strokeWidth: "1.408",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

export { PetsIcon };
